import { Modal, Input, Space } from 'antd';
import { useEffect, useState } from 'react';

export type ReplaceDataType = { ids: number[]; prop: string }

const Index = (handleReplaceKeyword: (data: ReplaceDataType, text: string) => Promise<boolean>) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [data, setData] = useState<ReplaceDataType>({ ids: [], prop: "" });
  const [text, setText] = useState<string>("");

  useEffect(() => {
    if (data.prop) setVisible(true);
  }, [data.prop]);

  function clear() {
    setVisible(false);
    setData({ ids: [], prop: "" });
    setText("");
  }

  return {
    E: <Modal
      title="替换关键字"
      visible={visible}
      onCancel={clear}
      onOk={async () => {
        if (await handleReplaceKeyword(data, text)) {
          clear();
        }
      }}
    >
      <Space direction="vertical">
        <Input
          value={text}
          placeholder="请输入替换为的文字！"
          onChange={(e) => setText(e.target.value)}
        />
        <h4>注：所查询的文字会被替换；替换的文字可以不填写；没有权限操作的问答，即使被勾选，也会被剔除；已落库的问答不支持批量替换！</h4>
      </Space>
    </Modal>,
    controller: {
      setData,
    }
  }
}

export default Index;